import React, {useContext, useState, useEffect} from "react";
import {Context} from "../..";
import { Button, Form, FloatingLabel} from "react-bootstrap";
import { CATALOG_ROUTE, CHECKOUT_DELIVERING_ROUTE, POSTING_SUCCESS } from "../../utils/const";
import {useNavigate} from "react-router-dom";
import {createMovePosting, createPosting, createDelivering } from "../../http/productAPI";
import { getStore, getStores } from "../../http/userAPI";

const BasketConfirm = ({ customerData, setErrors, setIsFormValid }) => {
    const {product} = useContext(Context)
    const {user} = useContext(Context)
    const navigate = useNavigate()
    const [stores, setStores] = useState([])
    const [storeId, setStoreId] = useState({id: 'c68d733c-e253-11ec-0a80-01540008c7ec'})
    
    const [payLink, setPayLink] = useState(null);



   useEffect(() => {
    // если нет авторизации не запрашивать склады
        if (!user.isAuth || !user.token) {
            return;
        }
        getStores(user).then(data => setStores(data))
        getStore(user).then(data => setStoreId(data))
    }, [user])


    // Перемещение в магазин
    const handleMoveCreate = async () => {
        if (product.basketProducts.length > 0) {
            try {                
                let data = await createMovePosting(user.user, product.basketProducts, storeId);
                if (data.status === 200) {
                    product.setBasketProducts([])
                    navigate(POSTING_SUCCESS)
                }
            } catch (e) {
                alert(e.response.data?.message)
            }
        } else {
            alert("Корзина пуста")
            navigate(CATALOG_ROUTE)
        }
    }

    // Оформить доставку до клиента
   /* const handleDostCreate = async () => {
        if (product.basketProducts.length > 0) {
            // Валидация обязательных полей
                const newErrors = {};
                if (!customerData?.recipient?.firstName) {
                  newErrors.recipient = {
                    ...newErrors.recipient,
                    firstName: "Это поле обязательно для заполнения",
                  };
                }

                if (!customerData?.recipient?.phone) {
                  newErrors.recipient = {
                    ...newErrors.recipient,
                    phone: "Это поле обязательно для заполнения",
                  };
                }

                if (!customerData?.recipient?.email) {
                  newErrors.recipient = {
                    ...newErrors.recipient,
                    email: "Это поле обязательно для заполнения",
                  };
                }
               
                if (!customerData.address) {
                  newErrors.address = "Это поле обязательно для заполнения";
                    }
            
                // Если есть ошибки, то не отправляем данные и показываем ошибку
                if (Object.keys(newErrors).length > 0) {
                  setErrors(newErrors);
                  setIsFormValid(false);
                  return;
                } */   
    const handleDostCreate = async () => {
    
      const newErrors = {};
    
      // Универсальная функция валидации
      const validateRequiredFields = (obj, fields, path) => {
        fields.forEach((field) => {
          if (!obj?.[field]) {
            if (!newErrors[path]) newErrors[path] = {};
            newErrors[path][field] = 'Это поле обязательно для заполнения';
          }
        });
      };
    
      // Проверка recipient
      validateRequiredFields(customerData.recipient, ['firstName', 'phone', 'email'], 'recipient');
    
      // Пример: если deliveringDate обязателен
      if (!customerData.deliveringDate) {
        newErrors.deliveringDate = 'Выберите дату доставки';
      }
    
      // Если есть ошибки — показываем их и отменяем отправку
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setIsFormValid(false);
            console.log ("newErrors", newErrors)
        return;
      }

      try {
        const currentAddress = {
                        tail: customerData.address.value,
                        city: customerData.address.data.city,
                        house: customerData.address.data.house,
                        street: customerData.address.data.street,
                        padik: customerData.address.data.padik,
                        flat: customerData.address.data.flat,
                        latitude: customerData.address.data.geo_lat,
                        longitude: customerData.address.data.geo_lon
                    }                   
        let data = await createDelivering(
          user.user,
          product.basketProducts,
          customerData.recipient,
          currentAddress,
          customerData.priceDost,
          customerData.comment,
          storeId,
          customerData.prr,
          customerData.deliveringDate     
        );
      
        if (data.status === 200) {
          const postingNumber = data?.meta?.postingNumber;
          product.setBasketProducts([]);
          navigate(POSTING_SUCCESS, { state: { postingNumber } });
        }
      } catch (e) {
        if (e.response?.data?.message) {
          alert(e.response.data.message);
        } else {
          console.error("Ошибка при оформлении доставки:", e);
          alert("Произошла неизвестная ошибка при оформлении доставки");
        }
      }
    };


    // Оформить заказ
  const handlePostingCreate = async () => {

    const newErrors = {};
    
      // Универсальная функция валидации
      const validateRequiredFields = (obj, fields, path) => {
        fields.forEach((field) => {
          if (!obj?.[field]) {
            if (!newErrors[path]) newErrors[path] = {};
            newErrors[path][field] = 'Это поле обязательно для заполнения';
          }
        });
      };
    
      // Проверка recipient
      validateRequiredFields(customerData.recipient, ['firstName', 'phone', 'email'], 'recipient');
    
      // Пример: если deliveringDate обязателен
      if (!customerData.deliveringDate) {
        newErrors.deliveringDate = 'Выберите дату доставки';
      }
    
      // Если есть ошибки — показываем их и отменяем отправку
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setIsFormValid(false);
            console.log ("newErrors", newErrors)
        return;
      }                                   
        try {  
                const currentUser = user.isAuth
                    ? user.user // авторизованный
                    : {
                    //    address: customerData.address.value,
                    //    city: customerData.city,
                       // email: customerData.email,
                        email: "site@evo7.ru",
                        id: 33,         // id с прода 
                    //    lastName: customerData.lastName,
                    //    latitude: customerData.address.data.geo_lat,
                    //    longitude: customerData.address.data.geo_lon,
                    //    name: customerData.fullName,
                    //    phoneNumber: customerData.phone,
                        //token:    ???
                      };
                const currentAddress = {
                        tail: customerData.address.value,
                        city: customerData.address.data.city,
                        house: customerData.address.data.house,
                        street: customerData.address.data.street,
                        padik: customerData.address.data.padik,
                        flat: customerData.address.data.flat,
                        latitude: customerData.address.data.geo_lat,
                        longitude: customerData.address.data.geo_lon
                    }                   
                   /*const recipient ={
                    firstName: customerData.fullName,
                    lastName: customerData.lastName,
                    phone: customerData.phone,
                    email:customerData.email
                   }*/

                    let data = await createPosting(currentUser, product.basketProducts, customerData.recipient, currentAddress, customerData.priceDost, customerData.comment);
//           let data = await createDelivering(user.user, product.basketProducts, customerData.fullName, customerData.lastName, customerData.phone, customerData.address.value, customerData.address.data.geo_lat, customerData.address.data.geo_lon, customerData.priceDost, customerData.comment, storeId);

            if (data) {
             //   window.location.href = data;  // в этой вкладке
                window.open(data, '_blank'); // в новой вкладке
             //  navigate('/pay_page', { state: { url: data} });  // попытка через фрейм открыть

            }
        } catch (e) {
            //alert(e.response.data?.message)
            if (e.response && e.response.data && e.response.data.message) {
                alert(e.response.data.message);
              } else {
                console.error("Ошибка при оформлении доставки:", e);
                alert("Произошла неизвестная ошибка при оформлении доставки");
              }
        
        } 
    }
      //  console.log("customerData for BasketConfirm", customerData)


    return (
        <>{product.basketSum > 0 ? (
                <div className="total-wrapper rounded-4 p-4">
                    {product.basketProducts?.length > 0 ? product.basketProducts?.map(basketProduct =>
                        <div key={basketProduct.id} className="products-list__elem d-flex mb-1 align-items-baseline mb-2">
                            <span className="products-list__name">{basketProduct.name} ({basketProduct.count} шт)</span>
                            <span className="products-list__dots flex-grow-1"></span>
                            <div className="products-list__value">
                                {basketProduct.isSale ? basketProduct.salePrice : basketProduct.price}
                                <span className="rub-icon">₽</span>
                            </div>
                        </div>
                    ) : (
                        <div className="products-list__elem d-flex mb-1 align-items-baseline mb-2">
                            <span className="products-list__name">Товаров нет</span>
                            <span className="products-list__dots flex-grow-1"></span>
                        </div>
                    )}
                    {product.basketProducts?.map(basketProduct =>
                        basketProduct.price * basketProduct.count
                    ).reduce((a, c) => a + c, 0) - product.basketSum > 0 ?
                    <div className="products-list__elem d-flex mb-1 align-items-baseline mb-2">
                        <span className="products-list__name">Ваша скидка</span>
                        <span className="products-list__dots flex-grow-1"></span>
                        <div className="products-list__value text-decoration-line-through">
                            {product.basketProducts?.map(basketProduct =>
                                basketProduct.price * basketProduct.count
                            ).reduce((a, c) => a + c, 0) - product.basketSum}
                            <span className="rub-icon">₽</span></div>
                    </div> : ('')}
                    <div className="products-list__elem d-flex mb-1 align-items-baseline justify-content-between mb-4">
                        <span className="chackout_total">Сумма заказа</span>
                        <div className="products-list__value"><span
                            className="first-price fw-bolder text-danger">{product.basketSum}<span
                            className="rub-icon">₽</span></span>
                        </div>
                    </div>

                    <div>
                            <Button
                                 className="text-light ms-auto d-flex align-items-center bg-danger rounded-4 p-2 justify-content-center w-100"
                                 variant={"red"}
                                 onClick={handlePostingCreate} >
                                 Оформить заказ
                            </Button>               
                    </div>
                    <div className="priceline d-flex align-items-center">
                        {user.hasRoleShop && (
                            <Form className="align-items-center rounded-4 justify-content-center w-100 mt-3">
                                <FloatingLabel controlId="floatingInputGrid" className="h6" label="Переместить на">
                                    <Form.Select aria-label="Переместить на" value={storeId.id}
                                                  onChange={(e) => {
                                                      setStoreId({id: e.target.value})
                                                  }}>
                                        {stores.map((entry) =>
                                             <option value={entry.id} key={entry.id}>{entry.name}</option>
                                        )}
                                </Form.Select>
                            </FloatingLabel>
                            <Button
                                 className="text-light ms-auto d-flex align-items-center bg-danger rounded-4 p-2 justify-content-center w-100"
                                 variant={"red"}
                                 onClick={handleMoveCreate} >
                                 Перемещение в магазин
                            </Button>            
                        </Form>)}
                    </div>
                        {user.hasRoleShop && (
                            <Button 
                                variant={"red"} 
                                className="text-light ms-auto d-flex align-items-center bg-danger rounded-4 p-2 justify-content-center w-100" 
                                onClick={handleDostCreate} >
                                    Оформить доставку до клиента
                            </Button>)}                            
                    
                </div>
        ) : ('')}</>
    );
};

export default BasketConfirm;